import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic, Table, Tag, Progress } from 'antd';
import {
  UserOutlined,
  BookOutlined,
  PlayCircleOutlined,
  TrophyOutlined,
} from '@ant-design/icons';
import { userApi } from '../../api';
import './Home.css';

const Home = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalCourses: 0,
    activeSessions: 0,
    completedCourses: 0,
  });
  const [recentCourses, setRecentCourses] = useState([]);

  // 模拟数据加载
  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    setLoading(true);
    try {
      // 这里可以调用真实的API
      // const usersRes = await userApi.getUsers({ page: 1, limit: 10 });
      
      // 模拟数据
      setStats({
        totalUsers: 1250,
        totalCourses: 48,
        activeSessions: 23,
        completedCourses: 156,
      });

      setRecentCourses([
        {
          key: '1',
          name: 'React基础教程',
          instructor: '张老师',
          students: 45,
          progress: 85,
          status: 'active',
        },
        {
          key: '2',
          name: 'JavaScript高级编程',
          instructor: '李老师',
          students: 32,
          progress: 60,
          status: 'active',
        },
        {
          key: '3',
          name: 'Vue.js实战项目',
          instructor: '王老师',
          students: 28,
          progress: 100,
          status: 'completed',
        },
        {
          key: '4',
          name: 'Node.js后端开发',
          instructor: '陈老师',
          students: 38,
          progress: 45,
          status: 'active',
        },
      ]);
    } catch (error) {
      console.error('加载仪表板数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: '课程名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '讲师',
      dataIndex: 'instructor',
      key: 'instructor',
    },
    {
      title: '学生数',
      dataIndex: 'students',
      key: 'students',
    },
    {
      title: '进度',
      dataIndex: 'progress',
      key: 'progress',
      render: (progress) => (
        <Progress percent={progress} size="small" />
      ),
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'active' ? 'green' : 'blue'}>
          {status === 'active' ? '进行中' : '已完成'}
        </Tag>
      ),
    },
  ];

  return (
    <div className="home-container">
      <h2>仪表板</h2>
      
      {/* 统计卡片 */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="总用户数"
              value={stats.totalUsers}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="总课程数"
              value={stats.totalCourses}
              prefix={<BookOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="活跃会话"
              value={stats.activeSessions}
              prefix={<PlayCircleOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="完成课程"
              value={stats.completedCourses}
              prefix={<TrophyOutlined />}
              valueStyle={{ color: '#eb2f96' }}
            />
          </Card>
        </Col>
      </Row>

      {/* 最近课程表格 */}
      <Card title="最近课程" loading={loading}>
        <Table
          columns={columns}
          dataSource={recentCourses}
          pagination={false}
          size="middle"
        />
      </Card>
    </div>
  );
};

export default Home;
